module.exports = __webpack_public_path__ + "static/media/main-logo.a56490a5.png";